export enum VisitFailureReason {
    VehicleNotOnSite,
    KitNotOnSiteCustomer,
    KitNotOnSiteAddsecure,
    VehicleNotAvailable,
    ThirdParty,
    OtherIssue,
    EngineerNotOnSite
}
